import { render, staticRenderFns } from "./AdminSuperCommunications.vue?vue&type=template&id=08e3b13e&"
import script from "./AdminSuperCommunications.vue?vue&type=script&lang=js&"
export * from "./AdminSuperCommunications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports